export default "__VITE_ASSET__B53iUv4a__"